// Browser-safe runtime entry: names, support links, label header, identifiers and logo
// URLs. Colours and fonts are NOT here: they are CSS tokens (`@enp/brand/tokens.css`).

import brandJson from '../generated/brand.json' with { type: 'json' };
import type { RuntimeBrand } from './runtime-types.js';

export type { RuntimeBrand } from './runtime-types.js';

export const brand: RuntimeBrand = brandJson as RuntimeBrand;

/** "<productName> <app label>", e.g. for window and document titles. */
export function appTitle(app: keyof RuntimeBrand['appNames']): string {
  return `${brand.productName} ${brand.appNames[app]}`;
}

/** Document title for a page: "Catalogue · <productName> Admin". */
export function pageTitle(page: string | undefined, app: keyof RuntimeBrand['appNames']): string {
  return page ? `${page} · ${appTitle(app)}` : appTitle(app);
}
